module.exports = __webpack_public_path__ + "static/media/Yates_HeadshotTiny.899c38fc.png";